import React from 'react';
import {SocialLogoRequestParams} from "./models/social-image-params";
import {Image} from "../image/image";
import {SocialMetadataModel} from "./models/social-metadata-model";

export const SocialIconLink = ({
                                 alt,
                                 title,
                                 size,
                                 name,
                                 url,
                                 className,
                                 nofollow
                               }) => {
  const socialMetaData: SocialMetadataModel = new SocialMetadataModel({alt, title});
  const socialLogoParams: SocialLogoRequestParams = new SocialLogoRequestParams(name, socialMetaData, size, size);

  const linkProps = {
    href: url,
    target: "_blank",
    rel: nofollow ? "nofollow" : undefined
  }

  const imageProps = {
    width: "auto",
    height: size,
    className,
    src: socialLogoParams,
    style: {
      maxWidth: "auto",
      maxHeight: size
    }
  }

  return (
    url ? <a  {...linkProps}>
      <Image {...imageProps}/>
    </a> : null
  );
}
